<script lang="tsx">
import type { UnwrapNestedRefs } from "vue";
import isArray from "lodash/isArray";
import $ from "jquery";
import { ElAffix, ElMessage, ElEmpty} from "element-plus";
import "../style.scss";
import loadDataMixFunc, { loadDataProps } from "../../../commonMix/loadData";
import HeaderMenu from "../HeaderMenu.vue";
import { renderInlineStyle } from "./render/index";
import { extractTextFromVNode } from "./render/index";
import { defineComponent, reactive, computed, nextTick, watch, h, onMounted, toRefs, onUpdated, onBeforeMount, onBeforeUnmount, onActivated, onDeactivated, ref } from "vue";
import type { PropType, ExtractPropTypes, ComputedRef, VNode, Slot, UnwrapRef, ComponentPublicInstance, Ref, CSSProperties } from "vue";
import type { LoadDataOperateType, LoadDataStateType, FetchApiInterface } from "../../../commonMix/loadData/types";
import type { DataTableType, DataTableColumnType, ElTableType, ElTablePropsType, HeaderMenuType, DataTableCompoundDataType, UseSortableDataType, UseSelectionType, UseScrollLoadDataType, UseVirtualListType, SelectedActionType } from "../types";
import {
  List,
  debounce,
  deburr,
  get,
  startCase,
  throttle,
  isObject,
  trim
} from "lodash-es";
import { buildProps, componentsPropsFilter } from "../../../utils/props";
import { useSortableData } from "./sortHook";
import { useSelection } from "./selectRowsHook";
import { useScrollLoadData } from "./scrollToLoadMore";
import { useVirtualList } from "./virtualListHook";
import { useRangDragToCopy } from "./rangDragToCopyHook";
import CustomScrollBar from "./CustomScrollBar.vue";
import SortTrigger from "./SortTrigger.vue";
import SimpleCheckbox from "./SimpleCheckbox.vue";
import HeaderColFilter from "./HeaderColFilter.vue";
import lodash from "lodash-es";
import { props } from "quick-vue-components/index";
import { number } from "@user-center/utils/validate";
import { CopyDocument,Search } from "@element-plus/icons-vue";
export const FastTableProps = {
  ...buildProps({
    tableHeaders: {
      type: Array as PropType<Array<DataTableColumnType>>,
      default: () => [],
    },
    targetScrollTopBottomWrapSelector:{
      type:String,
      default:".comp-datatable"
    },

    indexLabel:{
      type:String,
      default:"序号"
    },
    
    targetScrollBottomSelector:{
      type:String,
      default:".el-pagination-wrap"
    },
     targetScrollTopSelector:{
      type:String,
      default:".fast-table__head__thead"
    },
    sortable: {
      type: Boolean,
      default: false,
    },
    fixedVirtual: {
      type: Boolean,
      default: false,
    },
    virtualList: {
      type: Boolean,
      default: false,
    },
    positionScroll:{
      type: Boolean,
      default: false,
    },
    virtualDataLength: {
      type: Number,
      default: 50,
    },
    data: {
      type: Array as PropType<Array<any>>,
      default: () => [],
    },
    rowClassName: {
      type: [String, Function],
      default: "",
    },

    cellClassName: {
      type: [String, Function],
      default: "",
    },
    emptyText: {
      type: String,
      default: "",
    },
    rowKey: {
      type: [String, Function],
      default: "",
    },
    selectable: {
      type: Function,
      default: ()=>{
        return true
      },
    },
    isAllColCanCopy: {
      type: Boolean,
      default: false,
    },
    isAllColCanFilter: {
      type: Boolean,
      default: false,
    },
    selectRow: {
      type: Boolean,
      default: false,
    },
    rangDragToCopy: {
      type: Boolean,
      default: true,
    },
    showIdx: {
      type: Boolean,
      default: false,
    },
    baseIdx: {
      type: Number,
      default: 0,
    },
    dataToReScrollTop: {
      type: Boolean,
      default: true,
    },
    rowHeight: {
      type: Number,
      default: 0,
    },
    trPrependHeight: {
      type: Number,
      default: 0,
    },
    scrollToLoadMoreData: {
      type: Boolean,
      default: false,
    },

    scrollToLoadMoreDataLength: {
      type: Number,
      default: 50,
    },

    resizable: {
      type: Boolean,
      default: true,
    },
    height: {
      type: [Number, String],
      default: 400,
    },
    defaultColumnWidth: {
      type: [Number, String],
      default: 120,
    },
  }),
};
export type FastTablePropsType = ExtractPropTypes<typeof FastTableProps>;
export interface FastTableType
  extends UseSortableDataType,
    UseSelectionType,
    UseScrollLoadDataType,
    UseVirtualListType {
  indexThRender(): any;
  indexTdRender(row: any, rowIdx: number): string;
  scrollToRenderPlaceholder(): any[];
  virtualScrollPlaceholder(): any;

  toggleSelectAllRender(): any;
  toggleSelectRender(row: any): any;
  getRowListKey(row: any, i: number): string;
  getRowClass(row: any, i: number): any;
  getCellClass(
    row: any,
    rowIndex: number,
    column: any,
    columnIndex: number,
    isCanRender: boolean
  ): any;
  columnWidthHeaderPropMap: UnwrapNestedRefs<Record<string, number>>;
  showListData: ComputedRef<any[]>;
  cellRender(row: any, i: number, col: any, colIdx: number): any;
  startDrag(event: any, col: DataTableColumnType): void;
  onSortTriggerValChange(colIdx: number, val: string): void;
  onCellMouseenter(row: any, column: DataTableColumnType, e: any): void;
  onCellClick(row: any, column: DataTableColumnType, e: any): void;
  copyCol(col: any): void;
  _wholeColumnCopy(strList: any[], hint: boolean): void;
  selectedActionList: UnwrapNestedRefs<SelectedActionType[]>;
  doLayout(): void;
}
export default defineComponent({
  name: "FastTable",
  components: {
    HeaderColFilter,
    SortTrigger,
    SimpleCheckbox,
    CustomScrollBar
  },
  emits:["virtual-scroll", "cell-mouse-enter", "cell-click", "selection-change"],
  props: FastTableProps,
  setup(props: FastTablePropsType, ctx: any): FastTableType {
    const headTableEl: Ref<any> = ref(null);
    const columnWidthHeaderPropMap: UnwrapNestedRefs<Record<string, number>> =
      reactive({});

    let colFilterData: UnwrapNestedRefs<any> = reactive({valMap:{},colMap:{}});
    onBeforeMount(() => {
      makeInitColumnWidthHeaderPropMap(true);
    });

    let {
      
      sortedData,
      sortData,
      sortOrder,
      sortColumnIndex,
      sortOrOrgData,
      clearSort,
    } = useSortableData(props as any,colFilterData);

    let {
      isScrollToRender,
      tableScrollWrapEl,
      isScrollRenderData,
      remainingData,
      placeholderHeight,
    } = useScrollLoadData(props as any, sortOrOrgData as any);

    let {
      isVirtualScroll,
      virtualScrollRenderData,
      tableContWidth,
      tableHeaderHeight,
      startVirtualIndex,
      startThVirtualColIndex,
      endThVirtualColIndex,
      onTableWheel,
      positionScrollY,
      checkScrollXColFunc
    } = useVirtualList(props as any, sortOrOrgData as any, tableScrollWrapEl,ctx);

    let {
      selections,
      isSelected,
      toggleAllSelection,
      toggleSelection,
      clearSelection,
      selectAll,
      deselectAll,
      isAllSelected,
    } = useSelection(props, ctx);

     function getShowListData(){
        return showListData
      }
    let { selectedActionList } = useRangDragToCopy(
      props,
      ctx,
      sortOrOrgData,
      tableScrollWrapEl,
      getShowListData
    );
    watch(
      () => props.tableHeaders,
      () => {
        console.log("reset header");

        makeInitColumnWidthHeaderPropMap(false);
      }
    );
    watch(
      () => props.data,
      () => {
        if (props.dataToReScrollTop)
          $(tableScrollWrapEl.value as any).scrollTop(0);
      },
       
    );
    onBeforeUnmount(() => {
      // initHeaderDomScroll();
    });

    function makeInitColumnWidthHeaderPropMap(init: boolean): void {
      props.tableHeaders.map((o: DataTableColumnType) => {
        if (init || (!init && !columnWidthHeaderPropMap[o.prop])) {
          let setNumber: number = (
            o.width ? lodash.parseInt(o.width) : props.defaultColumnWidth
          ) as number;

          columnWidthHeaderPropMap[o.prop] = setNumber;
        }
      });
    }

    let scrollDom: any = null;
    let scrollHeaderTableDom: any = null;
    function initHeaderDomScroll(): void {}

    let startX = 0;
    let resizingProp: any = -1;
    let headerWidth = -1;
    function startDrag(event: any, col: DataTableColumnType): void {
      startX = event.pageX;
      resizingProp = col.prop;
      document.addEventListener("mousemove", handleDrag);
      document.addEventListener("mouseup", stopDrag);
      if (!$("#drag-table-line").get(0)) {
        let wrapElement: any = tableScrollWrapEl.value;
        if (wrapElement) {
          $(wrapElement).append(
            `<div id="drag-table-line" style="width:1px;background:#ccc;position:fixed;top:${
              ($(wrapElement) as any).offset().top
            }px;height:${props.height}px;" />`
          );
          $("#drag-table-line").css({
            left: event.pageX + "px",
          });
        }
      }
    }

    function handleDrag(event: any): void {
      if (resizingProp === -1) return;

      const offsetX = event.pageX - startX;

      headerWidth = columnWidthHeaderPropMap[resizingProp] + offsetX;

      if ($("#drag-table-line").get(0)) {
        $("#drag-table-line").css({
          left: event.pageX + "px",
        });
      }
    }

    function stopDrag(event: any): void {
      columnWidthHeaderPropMap[resizingProp] =
        headerWidth < 50 ? 50 : headerWidth;
      ctx.emit(
        "header-dragend",
        columnWidthHeaderPropMap[resizingProp],
        columnWidthHeaderPropMap[resizingProp],
        props.tableHeaders.find((o: any) => o.prop == resizingProp),
        event
      );
      resizingProp = -1;
      startX = 0;
      document.removeEventListener("mousemove", handleDrag);
      document.removeEventListener("mouseup", stopDrag);
      $("#drag-table-line").remove();
    }
    function onSortTriggerValChange(colIdx: number, val: string): void {
      sortColumnIndex.value = colIdx;
      sortOrder.value = val;
      // nextTick(() => {
      //   emit("sort-change");
      // });
    }
    function onCellMouseenter(
      row: any,
      column: DataTableColumnType,
      e: any
    ): void {
      ctx.emit("cell-mouse-enter", row, column, row[column.prop], e);
    }

    function onCellClick(row: any, column: DataTableColumnType, e: any): void {
      ctx.emit("cell-click", row, column, row[column.prop], e);
    }
    const showListData: ComputedRef<any[]> = computed(() => {
      let setData: any[] = sortOrOrgData.value;
      if (isScrollToRender.value) {
        setData = isScrollRenderData.value;
      }
      if (isVirtualScroll.value) {
        setData = virtualScrollRenderData.value;
      }

      return setData;
    });

    function getRowListKey(row: any, i: number): string {
      let setKey = i;
      if (props.rowKey) {
        if (typeof props.rowKey == "function") {
          setKey = props.rowKey(row, i) || i;
        } else if (typeof props.rowKey == "string") {
          setKey = row[props.rowKey] || i;
        }
      }
      return setKey + "";
    }
    function getRowClass(row: any, i: number): any {
      let rowClass = {
        "fast-table__body__tr": true,
      };
      if (typeof props.rowClassName == "function") {
        let setClass = props.rowClassName({
          row: row,
          rowIndex: i,
        });
        if (setClass) rowClass[setClass] = true;
      }
      return rowClass;
    }
    function getCellClass(
      row: any,
      rowIndex: number,
      column: any,
      columnIndex: number,
      isCanRender: boolean
    ): any {
      let cellClass = {
        "fast-table__body__td": true,
        "fast-table__body__td__fixed__left": column.fixed == "left",
        "fast-table__body__td__fixed__right": column.fixed == "right",
        [`fast-table__body__td__row${rowIndex}_column${columnIndex}`]: true,
      };
      if (props.rangDragToCopy && isCanRender && selectedActionList.length) {
        let isSelectCopyFixedClass = false;
        selectedActionList.map((o: SelectedActionType) => {
          let rowMinIndex = Math.min(o.startCell[0], o.endCell[0]);
          let rowMaxIndex = Math.max(o.startCell[0], o.endCell[0]);
          let colMinIndex = Math.min(o.startCell[1], o.endCell[1]);
          let colMaxIndex = Math.max(o.startCell[1], o.endCell[1]);

          if (
            !isSelectCopyFixedClass &&
            rowMinIndex <= rowIndex &&
            rowIndex <= rowMaxIndex &&
            colMinIndex <= columnIndex &&
            columnIndex <= colMaxIndex
          ) {
            isSelectCopyFixedClass = true;
          }
        });
        if (isSelectCopyFixedClass) {
          //在框选范围内
          cellClass["fast-table__body__td__fixed__will__copy"] = true;
        }
      }
      if (typeof props.cellClassName == "function") {
        let setCellClass = props.cellClassName({
          row: row,
          rowIndex: rowIndex,
          column: column,
          columnIndex: columnIndex,
        });
        if (setCellClass) cellClass[setCellClass] = true;
      }

      return cellClass;
    }

    function cellRender(row: any, i: number, col: any, colIdx: number): any {
      let isCanRender =
        !isVirtualScroll.value ||
        (colIdx >= startThVirtualColIndex.value &&
          colIdx <= endThVirtualColIndex.value) ||
        col.fixed;
      let renderVnode: any = null;
      if (isCanRender) {
        let findRowData = lodash.get(row, col.prop) || "";
        if (typeof findRowData == "number") {
          findRowData = findRowData + "";
        } else if (Array.isArray(findRowData)) {
          findRowData = findRowData.join(",");
        } else if (typeof findRowData == "object") {
          findRowData = JSON.stringify(findRowData);
        } else if (typeof findRowData != "string") {
          findRowData = "---";
        }
        renderVnode = findRowData;
        if (col.slots && col.slots.default) {
          renderVnode = col.slots.default({
            row: row,
            $index: i,
          });
        } else if (typeof col.formatter == "function") {
          renderVnode = col.formatter(row, col, get(row, col.prop), i);
        }
      }else{
        return ( <td />)
      }

      let cellClass = getCellClass(row, i, col, colIdx, isCanRender);
      let setTitle = "";
      if (col.showOverflowTooltip) {
        try {
          setTitle = extractTextFromVNode(renderVnode);
        } catch (e) {
          console.log(e);
        }
      }
      return (
        <td
          style={{
            right:col.fixedRight,
            display: col.hidden ? "none" : undefined,
          }}
          title={setTitle}
          onMouseenter={(e: any) => {
            onCellMouseenter(row, col, e);
          }}
          onClick={(e: any) => {
            onCellClick(row, col, e);
          }}
          class={cellClass}
          data-row-idx={i}
          data-col-idx={colIdx}
        >
          <div
            class={{
              "fast-table__body__td__cont": true,
              "fast-table__body__td__cont__nowrap": col.showOverflowTooltip,
            }}
          >
            {isCanRender ? (
              <div class="fast-table__body__td__cont__nowrap__inbox">
                {renderVnode}
              </div>
            ) : null}
          </div>
        </td>
      );
    }

    function toggleSelectAllRender(): any {
      return (
        <th
          class={{
            "fast-table__head__th": true,
            "fast-table__head__th__fixed__left": "left",
          }}
          style={{
            
            width: "40px",
          }}
        >
          <div class="fast-table__head__th__cont">
            <SimpleCheckbox
              checked={isAllSelected.value}
              indeterminate={!!(!isAllSelected.value && selections.length)}
              onChange={toggleAllSelection}
            ></SimpleCheckbox>
          </div>
        </th>
      );
    }

    function toggleSelectRender(row: any,idx:number): any {
      return (
        <td
          class={{
            "fast-table__body__td": true,
            "fast-table__body__td__fixed__left": "left",
          }}
          style={{
            width: "40px",
          }}
        >
          <div class="fast-table__body__td__cont">
            <SimpleCheckbox
              disabled={typeof props.selectable=='function'?!props.selectable(row,idx):false}
              checked={row.__selected}
              onChange={() => toggleSelection(row)}
            ></SimpleCheckbox>
          </div>
        </td>
      );
    }
    function indexThRender(): any {
      return (
        <th
          class={{
            "fast-table__head__th": true,
            "fast-table__head__th__fixed__left": "left",
          }}
          style={{
            width: "60px",
            left: props.selectRow ? "39px" : "-1px",
          }}
        >
          <div class="fast-table__head__th__cont fast-table__head__th__index__cont">{props.indexLabel}</div>
        </th>
      );
    }

    function indexTdRender(row: any, rowIdx: number): any {
      return (
        <td
          class={{
            "fast-table__body__td": true,
            "fast-table__body__td__fixed__left": "left",
          }}
          style={{
            width: "60px",
            left: props.selectRow ? "39px" : "-1px",
          }}
        >
          <div class="fast-table__body__td__cont">
            {props.baseIdx + rowIdx + 1}
          </div>
        </td>
      );
    }

    function scrollToRenderPlaceholder(): any[] {
      return remainingData.value.map((row: any, i: number) => {
        let setKey = getRowListKey(row, showListData.value.length + i);
        let rowClass = getRowClass(row, i);
        let hiddenColLength = 0;
        return (
          <tr key={setKey} data-key={setKey} class={rowClass}>
            {props.selectRow ? toggleSelectRender(row) : null}
            {[props.tableHeaders[0]].map((col, colIdx) => {
              if (!col.hidden) {
                return cellRender(row, i, col, colIdx);
              } else {
                hiddenColLength += 1;
                return cellRender(row, i, col, colIdx);
              }
            })}

            {i == 0 ? (
              <td colspan={props.tableHeaders.length - 1 - hiddenColLength}>
                <ElAffix offset={window.innerHeight - (props.height as number)}>
                  <div
                    style={{ height: props.rowHeight + "px" }}
                    class="loading-more-data"
                  >
                    <span v-loading={true} class="loading-more-data-icon" />
                    正在加载数据请稍后
                  </div>
                </ElAffix>
              </td>
            ) : null}
          </tr>
        );
      });
    }

    function virtualScrollPlaceholder(): any {
      return (
        <tbody
          style={{
            height:
              (props.data.length - showListData.value.length) *
                props.rowHeight +
              "px",
          }}
          class="fast-table__body__tbody fast-table__body__tbody__placeholder"
        >
          <tr>
            <td></td>
          </tr>
        </tbody>
      );
    }
    function copyCol(col: any): void {
      let strList: any[] = [];
      sortOrOrgData.value.map((o: any, i: number) => {
        let cellStr: any = "";
        if (col.slots && col.slots.default) {
          cellStr = extractTextFromVNode(
            col.slots.default({
              row: o,
              $index: i,
            })
          );
        } else if (typeof col.formatter == "function") {
          cellStr = extractTextFromVNode(
            col.formatter(o, col, get(o, col.prop), i)
          );
        } else {
          cellStr = get(o, col.prop) || "   ";
        }
        strList.push(cellStr);
      });
      _wholeColumnCopy(strList);
    }
    function _wholeColumnCopy(strList: any[], hint = true): void {
 
      let str = "";
      strList.forEach((v) => {
        if (str !== "") {
          str = `${str}\r${v}`;
        } else {
          str = `${v}`;
        }
      });
      let container: any = document.getElementsByClassName(
        "wholeColumnCopy-container"
      )[0];
      container.innerHTML = "";
      container.innerHTML = str;
      container.select();
      document.execCommand("Copy");
      if (hint) {
        ElMessage({
          message: "复制成功",
          type: "success",
        });
      }
    }

    function onHeaderColFilterChange(col:any,v:any){
 
     // colFilterData.valMap={}
       v= trim(v)
       if(!v){
        colFilterData.valMap[col.prop]="";
       }else{
        colFilterData.valMap[col.prop]=v;
       }
       colFilterData.colMap[col.prop]=col;
     
      sortOrOrgData.value;
      nextTick(()=>{
        if (props.dataToReScrollTop) $(tableScrollWrapEl.value as any).scrollTop(0);
      })
     
    }

    function theadRender(_ctx:any ): any {
      return (
              <thead
              class={{
                "fast-table__head__thead": true,
                "fast-table__head__render__thead": isVirtualScroll,
              }}
            >
              <tr class="fast-table__head__tr">
                {_ctx.$props.selectRow ? toggleSelectAllRender() : null}
                {_ctx.$props.showIdx ? _ctx.indexThRender() : null}

                {_ctx.$props.tableHeaders.map((col: any, colIdx: number) => {
                  let headerRender = col.slots && col.slots.header;
                  return (
                    <th
                      class={{
                        "fast-table__head__th": true,
                        "fast-table__head__render__th": isVirtualScroll,
                        "fast-table__head__th__fixed__left":
                          col.fixed == "left",
                        "fast-table__head__th__fixed__right":
                          col.fixed == "right",
                      }}
                      data-col-idx={colIdx}
                      style={{
                        right:col.fixedRight,
                        width: _ctx.columnWidthHeaderPropMap[col.prop] + "px",
                      }}
                    >
                      {_ctx.$props.resizable ? (
                        <div
                          onMousedown={(event) => _ctx.startDrag(event, col)}
                          id={"fast-table__head__th__drag__" + col.prop}
                          class="fast-table__head__th__drag"
                        ></div>
                      ) : null}

                      <div class="fast-table__head__th__cont">
                        {headerRender
                          ? headerRender({
                              column: col,
                              $index: colIdx,
                            })
                          : null}
                        {headerRender ? null : (typeof  col.label=='function'?col.label():col.label)}

                         {!headerRender &&
                        (typeof col.sortable == "boolean"||typeof col.sortable == "string"
                          ? col.sortable
                          : _ctx.sortable) ? (
                          <span class="fast-table__head__th__sort">
                            <SortTrigger
                              value={sortColumnIndex == colIdx ? sortOrder : ""}
                              {...{
                                ["onUpdate:value"]: (val: string): any =>
                                  onSortTriggerValChange(colIdx, val),
                              }}
                            />
                          </span>
                        ) : null}
                        {!headerRender && (_ctx.$props.isAllColCanCopy || col.copyCol) ? (
                          <span
                            onClick={() => copyCol(col)}
                            class="fast-table__head__th__copy__col"
                          >
                            <el-icon>
                              <CopyDocument />
                            </el-icon>
                          </span>
                        ) : null}
                        {!headerRender && (_ctx.$props.isAllColCanFilter || col.filterCol) ? (
                          <HeaderColFilter modelValue={colFilterData.valMap[col.prop]||''} onChange={(v)=>{ onHeaderColFilterChange(col,v); }} />
                        ) : null}
                      </div>
                    </th>
                  );
                })}
              </tr>
            </thead>

      );
    }
    return {
      colFilterData,
      positionScrollY,
      onTableWheel,
      clearSort,
      sortOrOrgData,
      cellRender,
      getRowListKey,
      getRowClass,
      getCellClass,
      onCellClick,
      onCellMouseenter,
      onSortTriggerValChange,
      columnWidthHeaderPropMap,
      startDrag,
      sortedData,
      sortData,
      showListData,
      sortOrder,
      sortColumnIndex,
      isScrollToRender,
      tableScrollWrapEl,
      isScrollRenderData,
      remainingData,
      placeholderHeight,
      isVirtualScroll,
      startVirtualIndex,
      virtualScrollRenderData,
      tableContWidth,
      tableHeaderHeight,
      startThVirtualColIndex,
      endThVirtualColIndex,
      checkScrollXColFunc,

      /*选择*/
      selections,
      isSelected,
      toggleAllSelection,
      toggleSelection,
      clearSelection,
      selectAll,
      deselectAll,
      isAllSelected,

      toggleSelectAllRender,
      toggleSelectRender,
      indexThRender,
      indexTdRender,
      scrollToRenderPlaceholder,
      virtualScrollPlaceholder,
      copyCol,
      _wholeColumnCopy,
      selectedActionList,
      doLayout() {},
      theadRender
    };
  },
  render(
    _ctx: ComponentPublicInstance<FastTablePropsType, FastTableType>
  ): VNode {
    const { tableHeaders, height, rowKey, rowHeight, isAllColCanCopy } =
      _ctx.$props;
    const {
      onTableWheel,
      sortColumnIndex,
      copyCol,
      sortOrder,
      onSortTriggerValChange,
      tableHeaderHeight,
      isScrollToRender,
      getRowListKey,
      getRowClass,
      tableContWidth,
      isVirtualScroll,
      remainingData,
      startVirtualIndex,
      toggleSelectAllRender,
      toggleSelectRender,
      positionScrollY
    } = _ctx;
 
    let isFixedRowHeightStyle = isScrollToRender || isVirtualScroll; //是否采用固定行样式
    return (
      <div class="fast-table__wrap__root">
        <textarea
          class="wholeColumnCopy-container"
          style="position: absolute; z-index: -9999;left:-9999px; top: 0"
        />
        <div
          ref="tableScrollWrapEl"
          style={{
            height: typeof height == "string" ? height : height + "px",
           
          }}
          class={{
            "fast-table__wrap": true,
            "fast-drag-table": _ctx.$props.resizable,
            ["scroll-render-row-height-" + rowHeight]: isFixedRowHeightStyle,
          }}
           onWheel={onTableWheel}
        >
          {_ctx.$slots && _ctx.$slots.headerTopBlock?_ctx.$slots.headerTopBlock({
              listData:_ctx.showListData,
              toggleSelection:_ctx.toggleSelection,
            }):null}

          {
            _ctx.$slots && _ctx.$slots.tablePrepend ? _ctx.$slots.tablePrepend({}) : null
          }

          {isFixedRowHeightStyle ? renderInlineStyle(rowHeight) : null}
          <div
          class={{
             "fast-table__scroll__in__wrap": true,
          }}
          style={ _ctx.$props.fixedVirtual?{
              overflow: 'visible',
              position: 'sticky',
              top: 0
            }:{}}
          > 
          <table 
           
            class={{
              
                "fast-table": true,
                "fast-table__fixed__virtual": _ctx.$props.fixedVirtual,
            }}
           >
           {_ctx.theadRender(_ctx)}
           
             {!_ctx.$slots ||! _ctx.$slots.tbodyWrap?
            <tbody
            
              class={{
                "fast-table__body__tbody": true,
                "fast-table__rangcopy__body__tbody": _ctx.$props.rangDragToCopy,
                "fast-table__body__render__tbody": isVirtualScroll,
              }}
              style={{
                
                'will-change':isVirtualScroll?'transform':undefined
              }}
            >
              {_ctx.showListData && _ctx.showListData.length
                ? _ctx.showListData.map((row: any, i: number) => {
                    let realIdx = isVirtualScroll ? startVirtualIndex + i : i;
                    let setKey = getRowListKey(row, realIdx);
                    let rowClass = getRowClass(row, realIdx);
                    let trPrependDom = null;
                    
                    let resDoms: any[] = [];
                    if (_ctx.$slots && _ctx.$slots.trPrepend) {
                      trPrependDom = (
                        <tr class="fast-table__body__tr__prepend" 
                          style={{height:typeof trPrependHeight=="number"?trPrependHeight+'px':trPrependHeight}}
                        >
                          <td colspan="1000">
                            {_ctx.$slots.trPrepend({
                              row,
                              rowIndex: realIdx,
                            })}
                          </td>
                        </tr>
                      );
                      resDoms.push(trPrependDom);
                    }

                    resDoms.push(
                      <tr key={_ctx.$props.fixedVirtual?i:setKey}  data-key={setKey} class={rowClass}>
                        {_ctx.$props.selectRow ? toggleSelectRender(row,realIdx) : null}
                        {_ctx.$props.showIdx
                          ? _ctx.indexTdRender(row, realIdx)
                          : null}
                        {tableHeaders.map((col, colIdx) =>
                          _ctx.cellRender(row, realIdx, col, colIdx)
                        )}
                      </tr>
                    );

                    return resDoms;
                  })
                : null}

              {isScrollToRender && remainingData.length
                ? _ctx.scrollToRenderPlaceholder()
                :  null}
            </tbody>
             :_ctx.$slots.tbodyWrap({
              listData:_ctx.showListData,
              toggleSelection:_ctx.toggleSelection,
            })}
            {isVirtualScroll ? _ctx.virtualScrollPlaceholder() : null}
          </table>
          
        </div>
         {_ctx.showListData && _ctx.showListData.length?null: <ElEmpty class="fast-table-empty" description={_ctx.$props.emptyText} />}
        { _ctx.$props.fixedVirtual?<div style={{height:(rowHeight*(_ctx.$props.data.length+3))+'px'} }/>:null}
       </div>
      </div>
    );
  },
});
</script>
<style lang="scss" scoped>
  .fast-table__wrap{
    --fast-table-th-font-size:12px;
    --fast-table-th-bg-color:#f1f1f1;
    --fast-table-border-color:#dfe6ec;
  }
  .fast-table__wrap__root{
    position: relative;
  }
  .loading-canvasBox {
      align-items: center;
      background: #fff;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      margin: 1em;
      width: 10em;
      height: 10em;
      position: absolute;
      left: calc( 50% - 5em );
      top: calc( 50% - 5em );
      // 第四种
    .loading-spinner {
      animation: spinnerFour 1s linear infinite;
      border: solid 7px transparent;
      border-top: solid 7px #ff6800;
      border-radius: 100%;
      width: 3em;
      height: 3em;
    }
 
    @keyframes spinnerFour {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
  .contantBox::before {
    content: "";
    position: absolute;
    margin: 2px;
    inset: 0 100% 0 0;
    border-radius: inherit;
    background: #514b82;
    animation: cartoon 2s infinite;
  }
 
  @keyframes cartoon {
    100% {
      inset: 0;
    }
  }
.fast-table__head__th {
  padding: 4px 0;
}
.fast-table__head__th__cont {
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  line-height: 23px;
  padding: 0 12px;
}

.fast-table__body__td {
  padding: 4px 0;
}
.fast-table__body__td__cont {
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  line-height: 23px;
  padding: 0 12px;
}

.fast-table__wrap {
  position: relative;
 
  overflow: auto;

  .fast-table {
    outline: 1px solid #dfe6ec;
    color: var(--el-text-color-primary);
    font-size: var(--fast-table-th-font-size);
    border-collapse: collapse;

    table-layout: fixed;
    width: 100%;
    // height: 100%;
    // overflow-x: auto;
    &.fast-table__fixed__virtual{
      .fast-table__head__thead {
        .fast-table__head__tr {
          .fast-table__head__th {
            top:auto;
          }
        }
      }
       .fast-table__body__tbody{
            border-bottom: 1px solid  var(--fast-table-border-color);
       }
    }
    .fast-table__head__thead {
      text-align: left;
      .fast-table__head__tr {
        position: relative;
        z-index: 3;
        .fast-table__head__th {
          border: 1px solid   var(--fast-table-border-color);
          font-weight: bold;
          vertical-align: middle;

          box-sizing: border-box;

          position: sticky;
          top: 0px;
          background-color:  var(--fast-table-th-bg-color);
          &::after {
            content: "";
            position: absolute;
            left: 0px;
            right: 0px;
            height: 1px;
            bottom: -1px;
            background:  var(--fast-table-border-color);
          }
          &.fast-table__head__th__fixed__left {
            position: sticky;
            left: -1px;
            z-index: 2;
            background:  var(--fast-table-th-bg-color);
            &::before {
              content: "";
              position: absolute;
              top: 0px;
              width: 1px;
              bottom: 0px;

              right: -1px;
              background:  var(--fast-table-border-color);
            }
          }
          &.fast-table__head__th__fixed__right {
            position: sticky;
            right: -1px;
            z-index: 999;
            background: var(--fast-table-th-bg-color);
            &::before {
              content: "";
              position: absolute;
              top: 0px;
              width: 1px;
              bottom: 0px;

              left: -1px;
              background:   var(--fast-table-border-color);
            }
          }
        }
      }
    }

    .fast-table__body__tbody {
      // height: 536px;
       background-color: #fff;

      .fast-table__body__tr {
        &:hover {
          .fast-table__body__td {
            background: #f5f7fa;
            &.fast-table__body__td__fixed__left,
            &.fast-table__body__td__fixed__right {
              background: #f5f7fa;
            }
          }
        }
        .fast-table__body__td {
          vertical-align: middle;
          border: 1px solid #dfe6ec;

          box-sizing: border-box;

          &.fast-table__body__td__fixed__left {
            position: sticky;
            left: -1px;
            background: #fff;
            &::before {
              content: "";
              position: absolute;
              top: 0px;
              width: 10px;
              bottom: -1px;
              overflow-x: hidden;
              overflow-y: hidden;
              box-shadow: none;
              touch-action: none;
              pointer-events: none;
              right: -10px;
              box-shadow: inset 10px 0px 10px -10px rgba(0, 0, 0, 0.15);
            }
          }

          &.fast-table__body__td__fixed__right {
            position: sticky;
            background: #fff;
            right: -1px;
            &::before {
              content: "";
              position: absolute;
              top: 0px;
              width: 10px;
              bottom: -1px;
              overflow-x: hidden;
              overflow-y: hidden;
              box-shadow: none;
              touch-action: none;
              pointer-events: none;
              left: -10px;
              box-shadow: inset -10px 0 10px -10px rgba(0, 0, 0, 0.15);
            }
          }
        }
      }
    }
  }
}
.fast-table__head__th__drag {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  cursor: col-resize;
}
.fast-drag-table {
  .fast-table__head__th {
    user-select: none;
  }
}
.fast-table__head__th__sort {
  vertical-align: bottom;
  display: inline-block;
  height: 24px;
  width: 1px;
}
.fast-table__head__th__search__col{
 
  height: 24px;
  width: 24px;
  cursor: pointer;
  margin-left: 9px;
 
}
.fast-table__head__th__copy__col {
  vertical-align: bottom;
  display: inline-flex;
  height: 24px;
  width: 24px;
  cursor: pointer;
  margin-left: 9px;
  justify-content: center;
  align-items: center;
}
.fast-table__body__td__cont__nowrap {
  white-space: nowrap;
}
.loading-more-data {
  padding: 0px 40px;
  .loading-more-data-icon {
    width: 34px;
    transform: scale(0.5);
    height: 34px;
    display: inline-block;
    vertical-align: middle;
  }
}
.fast-table__rangcopy__body__tbody {
  // user-select: none;
  >.fast-table__body__tr>.fast-table__body__td {
     user-select: none;
     >.fast-table__body__td__cont{
      user-select: none;
     }
     &:hover {
      user-select: none !important;
    }
  }
}
.fast-table__body__render__tbody {
  
  .fast-table__body__td {
    border: none !important;
    box-shadow: inset 1px 1px 0px 0px #dfe6ec;
  }
}
.fast-table__head__render__thead {
  .fast-table__head__th {
    border: none !important;
    box-shadow: inset 1px 1px 0px 0px #dfe6ec;
  }
}

.fast-table__wrap .fast-table__body__tr .fast-table__body__td__drag__will__copy {
  background-color: #2a364f !important;
  color: #fff !important;
  user-select: none !important;
}
.fast-table__wrap .fast-table__body__tr .fast-table__body__td__fixed__will__copy {
  background-color: #2a364f !important;
  color: #fff !important;
  user-select: none !important;
}

.fast-table__body__td__cont__nowrap__inbox {
  min-width: 100%;

  min-height: 10px;
}

.scrollbar {
  position: absolute;
  background: rgba(0, 0, 0, 0.3);
}

.scrollbar-horizontal {
  height: 10px;
  bottom: 0;
  left: 0;
  right: 0;
}

.scrollbar-vertical {
  width: 10px;
  top: 0;
  bottom: 0;
  right: 0;
}

.scrollbar-thumb {
  background: rgba(0, 0, 0, 0.6);
  position: absolute;
  cursor: pointer;
}

.fast-table__fixed__virtual{
  position: absolute;

}
.fast-table-empty{
  position:sticky;
  left:0;
}
</style>
